import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import HomeCareAppointmentDetailComponent from "src/Components/GlobalComponents/HomeCareAppointmentDetailComponent";

const CustomerHomecareAppointmentDetail: React.FC = () => {
  const { id = "" } = useParams();
  const navigate = useNavigate();
  return (
      <div className="w-full bg-banner-white-image p-3 lg:p-[0.5vw]">
        <div className="inner-max-width mx-auto">
          <HomeCareAppointmentDetailComponent
            appoinmentId={id}
            userRole="customer"
          />
        </div>
      </div>
  );
};

export default CustomerHomecareAppointmentDetail;
